/**
 * Counts the number of keys in an object
 * @param obj - The object to count keys for (can be null, undefined, or any value)
 * @returns The number of keys in the object, or 0 if not a valid object
 */
export function countKeys(obj: unknown): number {
  if (obj && typeof obj === "object" && obj !== null) {
    return Object.keys(obj as Record<string, unknown>).length
  }
  return 0
}
